import { View, XStack } from 'tamagui'
import { HeroIcon } from '@components/HeroIcon'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface ICenterControlsProps {
  onSkipBackward: () => void
  onSkipForward: () => void
  onPlayPause: () => void
  isPlaying: boolean
  advanceBackwardSize: number
  playPauseCenterSize: number
  backLabel: string
  skipLabel: string
  playPauseLabel: string
}

export function CenterControls({
  onSkipBackward,
  onSkipForward,
  onPlayPause,
  isPlaying,
  advanceBackwardSize,
  playPauseCenterSize,
  backLabel,
  skipLabel,
  playPauseLabel,
}: ICenterControlsProps) {
  const playPauseIcon: IconProp = isPlaying ? ['fas', 'pause'] : ['fas', 'play']
  return (
    <XStack
      position="absolute"
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      backgroundColor="rgba(0, 0, 0, 0.4)"
      gap="$spacing-inset-sm"
      zIndex={5}
    >
      <View
        onPress={onSkipBackward}
        role="button"
        aria-label={backLabel}
        justifyContent="center"
        alignItems="center"
        borderRadius="$border-radius-pill"
        padding="$spacing-inset-quarck"
      >
        <HeroIcon
          icon={'voltar10s'}
          size={advanceBackwardSize}
          color="$text-on-media"
        />
      </View>

      <View
        onPress={onPlayPause}
        role="button"
        aria-label={playPauseLabel}
        borderRadius="$border-radius-pill"
        padding="$spacing-inset-nano"
      >
        <HeroIcon
          icon={playPauseIcon}
          size={playPauseCenterSize}
          color="$text-on-media"
        />
      </View>

      <View
        onPress={onSkipForward}
        role="button"
        aria-label={skipLabel}
        justifyContent="center"
        alignItems="center"
        borderRadius="$border-radius-pill"
        padding="$spacing-inset-quarck"
      >
        <HeroIcon
          icon={'avancar10s'}
          size={advanceBackwardSize}
          color="$text-on-media"
        />
      </View>
    </XStack>
  )
}
